import { createContext } from 'react';
import { ILanguages, IUpdateWordings, IWordingsGroup } from 'types';

export type TWordingsSelectedItem = { id: string | null; name: string | null };
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error';
export interface IDeleteWordingData {
	groupId: string;
	wordingId: string;
}

export interface IWordingsState {
	selectedGroup: TWordingsSelectedItem | null;
	selectedLanguage: TWordingsSelectedItem | null;
	availableLanguages: ILanguages[];
	groups: IWordingsGroup[];
	invalidFields: string[];
	dataForSubmit: IUpdateWordings | null;
	deleteWordingData: IDeleteWordingData | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const wordingsInitialState: IWordingsState = {
	selectedGroup: null,
	selectedLanguage: null,
	availableLanguages: [],
	groups: [],
	invalidFields: [],
	dataForSubmit: null,
	deleteWordingData: null,
	typeOfModalWindow: null,
};

export interface IWordingsContext extends IWordingsState {
	setGroup(value: TWordingsSelectedItem | null): void;
	setLanguage(value: TWordingsSelectedItem | null): void;
	addInvalidField(value: string): void;
	clearInvalidFields(): void;
	removeWording(groupId: string, wordingId: string): void;
	setDataForSubmit(value: IUpdateWordings | null): void;
	setDeleteWordingData(value: IDeleteWordingData | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const WordingsContext = createContext<IWordingsContext>({
	setGroup: () => undefined,
	setLanguage: () => undefined,
	addInvalidField: () => undefined,
	clearInvalidFields: () => undefined,
	removeWording: () => undefined,
	setDataForSubmit: () => undefined,
	setDeleteWordingData: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...wordingsInitialState,
});
